import { useSearchParams } from 'react-router-dom'
import { InvestmentsTable } from './investments-table/InvestmentsTable'

function InvestmentsTab() {
  const [searchParams] = useSearchParams()
  const investmentId = searchParams.get('investmentId')

  return (
    <div className="grow md:pt-5">
      <InvestmentsTable investmentId={investmentId} />
    </div>
  )
}

export { InvestmentsTab }
